import React, { useState } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { translate } from '../../../services/translate';
import MyAppText from '../../MyAppText';
import { faChevronDown, faChevronUp, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { TextMask } from 'react-native-masked-text';

export default function OccurrenceFormGuardianApp({ occurrence }: { occurrence: Occurrence; }) {
    const { styles, theme } = useStyles(styleSheet);
    const [showDetails, setShowDetails] = useState<boolean>(false);

    if (occurrence.triggerType != 'guardian_app' || !occurrence.externalReference) {
        return <></>;
    }

    return (
        <ScrollView contentContainerStyle={{ rowGap: 10 }}>
            <View style={{ gap: 5 }}>
                <MyAppText style={styles.text}>{translate('requester')}</MyAppText>
                <MyAppText>{translate('name')}: {occurrence.externalReference.name}</MyAppText>
            </View>

            <View style={styles.generalInformation}>
                <TouchableOpacity
                    style={styles.generalInformationDropdown}
                    onPress={() => setShowDetails(!showDetails)}>
                    <MyAppText>{translate('general_info')}</MyAppText>
                    <FontAwesomeIcon icon={showDetails ? faChevronUp : faChevronDown} color={theme.colors.iconColor} />
                </TouchableOpacity>
                <View style={styles.tableLine}></View>
            </View>

            {showDetails ? <>
                <View style={{ gap: 5 }}>
                    <MyAppText>{translate('phone')}: {occurrence.externalReference.phone}</MyAppText>
                    <MyAppText>{translate('phone')} IMEI: {occurrence.externalReference.imei}</MyAppText>
                    <View style={{ flexDirection: 'row', gap: 5 }}>
                        <MyAppText>CPF:</MyAppText>
                        <TextMask
                            style={styles.documentText}
                            value={occurrence.externalReference.document ?? undefined}
                            type={'cpf'}
                        />
                    </View>
                    <MyAppText>{translate('email')}: {occurrence.externalReference.email}</MyAppText>
                    <MyAppText>{translate('birth')}: {occurrence.externalReference.birth ? occurrence.externalReference.birth : ''}</MyAppText>
                    <MyAppText>{translate('address')}: {occurrence.externalReference.address}</MyAppText>
                </View>
                <View style={{ gap: 3 }}>
                    <MyAppText style={styles.text}>{translate('location')}</MyAppText>
                    <View style={styles.visualizedRow} >
                        <FontAwesomeIcon icon={faCalendarCheck} style={{ width: 14 }} color={theme.colors.iconColor} />
                        <MyAppText style={styles.detectionInfoText}>
                            {moment(new Date(occurrence.createdAt)).format('DD/MM/YYYY HH:mm:ss')}
                        </MyAppText>
                    </View>
                    <View style={styles.visualizedRow} >
                        <FontAwesomeIcon icon={faLocationDot} style={{ width: 14 }} color={theme.colors.iconColor} />
                        <MyAppText style={styles.detectionInfoText}>
                            {occurrence.address}
                        </MyAppText>
                    </View>
                </View></> : <></>}

        </ScrollView>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    visualizedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },
    detectionInfoText: {
        color: theme.colors.textColor,
        fontSize: 12
    },
    text: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 16
    },
    infoText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 24
    },
    documentText: {
        fontFamily: 'Open Sans',
        color: theme.colors.textColor,
        fontSize: 14
    },
    tableLine: {
        borderBottomColor: theme.colors.card.border,
        borderBottomWidth: 1,
        flex: 1
    },
    generalInformation: {
        flexDirection: 'column',
        paddingHorizontal: 5,
        flex: 1,
        gap: 10
    },
    generalInformationDropdown: {
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
    }
}));
